import Vue from 'vue'
import BlockAnimation from '@/components/BlockAnimation'

Vue.component('FBlockAnimation', BlockAnimation)
